import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const {
  dashboard: { getDashboardRevenue },
} = apiUrls;

export const DASHBOARD_REVENUE_DETAILS_SUCCESS = 'DASHBOARD_REVENUE_DETAILS_SUCCESS';
export const DASHBOARD_REVENUE_DETAILS_LOADING = 'DASHBOARD_REVENUE_DETAILS_LOADING';

export const getDashboardRevenueData =
  ({ fromdate, todate, vendor }) =>
    async (dispatch) => {
      try {
        const { url } = getDashboardRevenue;
        const requestData = {
          ...getDashboardRevenue,
          url: url.replace('{{fromDate}}', fromdate).replace('{{toDate}}', todate).replace('{{vendor}}', vendor)
        };
        const data = await REQUEST(requestData);
        dispatch({
          type: DASHBOARD_REVENUE_DETAILS_SUCCESS,
          data,
          vendor
        });
      } catch (e) {
        dispatch({
          type: DASHBOARD_REVENUE_DETAILS_SUCCESS,
          data: {
            code: '',
            modal: null,
            notifications: null,
            paginationInfo: null,
          },
          vendor
        });
      }
    };

export const handleDashboardRevenueLoader = (isLoading, vendor) => (dispatch) => {
  dispatch({
    type: DASHBOARD_REVENUE_DETAILS_LOADING,
    isLoading,
    vendor
  });
};
